import * as types from "./actionTypes";

export const getLogin = (payload) => dispatch => {
    dispatch({ type: types.LOGIN_REQ });
    dispatch({ type: types.LOGIN_SUCC,payload });
    dispatch({type:types.LOGIN_FAIL})
}
